import React from "react";
import { XCircleIcon } from "@heroicons/react/24/solid";

export default function ComingSoon({showPopup}) {
  return (
    <div className="h-screen fixed w-full bg-black/25 flex items-center justify-center z-50 dark:text-white top-0 left-0">
      <div className="py-10 px-16 shadow-2xl  bg-white relative dark:bg-content bg-center bg-cover lg:w-4/12 rounded-3xl flex items-center flex-col">
        <XCircleIcon onClick={showPopup} className="h-8 text-gray-400 hover:text-gray-200 absolute right-0 top-0 m-5 cursor-pointer" />
        <h1 className="text-center text-4xl font-bold">Coming soon</h1>
        <button onClick={showPopup} className="py-3 px-6 bg-purple-500 hover:bg-purple-600 mt-5 rounded-full cursor-pointer text-white">
          Close
        </button>
      </div>
    </div>
  );
}
